import { ActionTree } from 'vuex';
import { home, common } from '../request';
import router from '../router';
import aliasMap from '@hewitt/paper/aliasMap';

let _router = router as any;

const actions: ActionTree<any, any> = {
  async getUserInfo({ commit }) {
    const res: any = await common.getUserInfo();
    if (res && res.code === 0 && res.result) {
      commit('SET_USERINFO', res.result);
    }
  },

  async getEvaluationUserInfo({ commit }) {
    const res: any = await home.getEvaluationUserInfo();
    const currentRoute = _router.history.current;
    if (res && res.code === 0 && res.result) {
      switch (res.result.status) {
        case 'UN_REGISTERED':
          if (currentRoute.path === '/home') return;
          router.push('/home');
          return;
        case 'UN_FINISHED':
          if (currentRoute.path === '/home') return;
          router.push('/home');
          return;
        case 'FINISHED':
          if (currentRoute.path !== '/result') {
            // router.push('/result');
          }
      }
      commit('SET_EVALUATIONUSERINFO', res.result.evaluationResult);
    }
  },
  // 测评新设计接口
  async findUserEvaluation({ commit }) {
    const currentRoute = _router.history.current;
    const { testPaper } = currentRoute.params;
    const res: any = await home.findUserEvaluation({
      evaluationAlias: aliasMap[testPaper]
    });
    if (res && res.code === 0 && res.result) {
      if (
        res.result.hasQualification === 'OFF' ||
        res.result.finishStatus === 'NOT_FINISH'
      ) {
        if (currentRoute.name === 'EvaluationHome') return;
        router.push({
          name: 'EvaluationHome',
          params: { testPaper },
          query: currentRoute.query
        });
      }
      if (res.result.finishStatus === 'IS_FINISH') {
        //
      }
      commit('SET_USEREVALUATIONINFO', res.result);
    } else {
      router.push({
        name: 'EvaluationHome',
        params: { testPaper },
        query: currentRoute.query
      });
    }
  }
};

export default actions;
